import { render, staticRenderFns } from "./Wellwisher.vue?vue&type=template&id=43ee5796"
import script from "./Wellwisher.vue?vue&type=script&lang=js"
export * from "./Wellwisher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports